import * as React from 'react';
export function FolderIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "12",
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 4.5V10.5C13.125 10.8978 12.9768 11.2794 12.7131 11.5607C12.4494 11.842 12.0917 12 11.7188 12H1.40625C1.03329 12 0.675604 11.842 0.411881 11.5607C0.148158 11.2794 0 10.8978 0 10.5V1.5C0 1.10218 0.148158 0.720644 0.411881 0.43934C0.675604 0.158035 1.03329 0 1.40625 0H3.89531C4.08328 0.000146078 4.26931 0.0404867 4.44242 0.118637C4.61552 0.196788 4.77217 0.311163 4.90312 0.455L7.09219 2.85C7.1356 2.89724 7.18737 2.93483 7.2445 2.96058C7.30163 2.98633 7.36298 2.99973 7.425 3H11.7188C12.0917 3 12.4494 3.15804 12.7131 3.43934C12.9768 3.72064 13.125 4.10218 13.125 4.5Z",
    fill: "#2B87DB"
  }));
}